import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer, Provider } from '@angular/core';
import { CanActivateFn, ROUTES } from '@angular/router';
import { InterpolatableTranslationObject, TranslateStore } from '@ngx-translate/core';

import { I18nService } from 'shared-modules-angular/i18n';

import { TILING_CANVAS_ROOT_PATH } from './tiling-canvas-paths';

export type TilingCanvasConfig = {
  communication: Provider,
  palettes: Provider,
  guardFn: CanActivateFn,
};

export function provideTilingCanvas(config: TilingCanvasConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ROUTES,
      multi: true,
      useValue: [
        {
          path: TILING_CANVAS_ROOT_PATH,
          pathMatch: 'full',
          canActivate: config.guardFn ? [config.guardFn] : [],
          loadComponent: () => import('../components/tiling-canvas/tiling-canvas.component').then(c => c.TilingCanvasComponent),
        },
      ],
    },
    config.communication,
    config.palettes,
    provideAppInitializer(async () => {
      const translateStore: TranslateStore = inject(TranslateStore);
      const i18nService: I18nService = inject(I18nService);

      await Promise.all(i18nService.getAvailableLanguages().map(async (lang) => {
        try {
          const libTranslations: InterpolatableTranslationObject = await import(`../assets/i18n/${lang}.json`);
          const appTranslations: InterpolatableTranslationObject = translateStore.getTranslations(lang);

          translateStore.setTranslations(lang, libTranslations, true);
          translateStore.setTranslations(lang, appTranslations, true);
        } catch (e) {
          console.error(`Error merging translations for lang [${lang}]: ${e}`);
        }
      }));

      return undefined;
    }),
  ]);
}
